<template>
  <div class="banner">
    <div class="main-width">
      <div class="flex items-center justify-between mt-22">
        <div class="banner-text">
          <div style="text-shadow: 0px 0px 50px rgba(0, 0, 0, 0.8)">
            <p class="text1">加盟合作</p>
            <p class="text1">轻松赚钱</p>
          </div>
          <div class="text2">专业的“邮轮+高端旅游” 商家服务平台</div>

          <template v-if="loggedIn">
            <nuxt-link to="/resource" class="btn" v-if="isDistributor"
              >前往商家中心</nuxt-link
            >
            <template v-else>
              <nuxt-link to="/settled/process" class="btn" v-if="approvaling"
                >查看审核结果</nuxt-link
              >
              <nuxt-link to="/settled/process" class="btn" v-else
                >成为合作伙伴</nuxt-link
              >
            </template>
          </template>
        </div>
        <div>
          <client-only>
            <!-- 使用 v-show 替换 v-if， v-if 组件销毁后会导致事件无法抵达  -->
            <div class="pannel" v-show="!loggedIn">
              <login-swiper
                @login-success="onLoginSuccess"
                @register-success="onLoginSuccess"
              />
            </div>
          </client-only>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import { distributorInfo } from "@/services/settled.js";
// import useRequest from "@/composables/useRequest";

// import Login from "./Login.vue";
// import Register from "./Register.vue";
import {
  useRoute,
  useRouter,
  useStore,
  computed,
} from "@nuxtjs/composition-api";

import LoginSwiper from "~/components/Login/login-swiper.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    // Register,
    // Login,
    LoginSwiper,
  },
  setup() {
    // const { state: info, error } = useRequest(distributorInfo, {});
    const store = useStore();
    const info = computed(() => {
      return store.state.user.distributorInfo;
    });

    const router = useRouter();

    function onLoginSuccess(data) {
      console.log("onLoginSuccess");
      if (data.admin.distributor) {
        router.replace("/resource");
      } else {
        router.replace("/settled/process");
      }
    }
    function onRegisterSuccess(data) {}
    return {
      info,
      onLoginSuccess,
      onRegisterSuccess,
    };
  },
  data() {
    return {};
  },
  computed: {
    swiperRef() {
      return this.$refs.swiper.$swiper;
    },
    auth() {
      // return this.$auth.$state;
      return this.$store.state.auth;
    },
    ...mapGetters(["loggedIn", "isDistributor"]),
    // loggedIn() {
    //   return this.$store.getters.loggedIn;
    // },
    // isDistributor() {
    // 	if (!this.loggedIn) return false;
    // 	return !!this.$store.getters.isDistributor;
    // },
    approvaling() {
      console.log(this.info);
      return this.info?.approval_status == "1";
    },
  },
  // methods: {
  //   toPrev() {
  //     this.swiperRef.slidePrev();
  //   },
  //   toNext() {
  //     this.swiperRef.slideNext();
  //   },
  // },
};
</script>
<style lang="scss" scoped>

.banner {
  height: 540px;
  background: url("~/assets/img/home/home_banner1.png") no-repeat center;
  background-size: cover;
  background-origin: content-box;
  position: relative;
  background-color: #6f5ff4;
}
.main-width {
  height: 100%;
}

.banner-text {
  margin-left: -15px;
  margin-top: -10px;
}

.text1 {
  width: 404px;
  font-size: 83px;
  font-weight: 900;
  color: #ffffff;
  line-height: 144px;
  text-shadow: 1px 0 0 #fff;
  margin-left: -10px;
}
.text1:first-child {
  margin-bottom: -28px;
}

.text2 {
  width: 546px;
  height: 64px;
  background: rgba(0, 0, 0, 0.72);
  border-radius: 50px 50px 50px 50px;
  text-align: center;
  font-size: 30px;
  font-weight: 600;
  color: #ffffff;
  line-height: 64px;
  margin-left: -14px;
}

.btn {
  // position: absolute;
  display: inline-block;
  width: 200px;
  height: 55px;
  text-align: center;
  line-height: 55px;
  font-size: 26px;
  color: #212529;
  font-weight: 600;
  border-radius: 10px;
  overflow: hidden;
  user-select: none;
  cursor: pointer;
  bottom: 120px;
  left: -10px;
  background: linear-gradient(180deg, #ffd96d 0%, #cea74c 100%);
  margin-top: 30px;
  //   transition: 0.3s background ease;
  &:hover {
    background: linear-gradient(180deg, #ffd400 0%, #ff8a00 100%);
  }
}
.pannel {
  // position: absolute;
  right: 20px;
  top: 50%;
  // transform: translateY(-50%);
  // margin-top: 50px;
}

</style>
